module.exports = __webpack_public_path__ + "img/97.9e06b786.jpg";